var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27273 18.355H19.7273C20.4298 18.355 21 17.6446 21 16.7692V1.70398C21 0.828608 20.4298 0.118164 19.7273 0.118164H1.27273C0.570182 0.118164 0 0.828608 0 1.70398V16.7692C0 17.6446 0.570182 18.355 1.27273 18.355ZM31.5 3.15764C31.5 2.0825 30.4283 1.34732 29.443 1.74658L24.4686 3.7623C23.2542 4.25415 22.5 5.5269 22.5 6.90348V11.5691C22.5 12.9462 23.2542 14.2185 24.4688 14.7103L29.4428 16.7265C30.4281 17.1259 31.5 16.3907 31.5 15.3155V3.15764Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.1fb72dc9298d832e78b5a1c282e31436.svg";
export { ForwardRef as ReactComponent };